function axiGetFavorites() {
  try { return JSON.parse(localStorage.getItem('axi_favorites') || '[]'); }
  catch (e) { return []; }
}
function axiSaveFavorites(list) {
  localStorage.setItem('axi_favorites', JSON.stringify(list));
}
function axiShowToast(message) {
  var existing = document.getElementById('axi-fav-toast');
  if (existing) existing.remove();
  var toast = document.createElement('div');
  toast.id = 'axi-fav-toast';
  toast.textContent = message;
  toast.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#111;color:#fff;padding:10px 18px;border-radius:6px;font-size:13px;font-weight:600;z-index:99999;opacity:0;transition:opacity 0.2s ease;';
  document.body.appendChild(toast);
  requestAnimationFrame(function () { toast.style.opacity = '1'; });
  setTimeout(function () {
    toast.style.opacity = '0';
    setTimeout(function () { toast.remove(); }, 200);
  }, 1200);
}
function axiUpdateHeaderBadge() {
  var count = axiGetFavorites().length;
  var badge = document.getElementById('axi-fav-badge');
  var bubble = document.getElementById('axi-fav-bubble');
  if (!badge || !bubble) return;
  if (count > 0) {
    badge.textContent = count;
    bubble.style.display = '';
  } else {
    bubble.style.display = 'none';
  }
}
function axiToggleFavorite(btn) {
  var id = btn.dataset.productId;
  var handle = btn.dataset.productHandle;
  var list = axiGetFavorites();
  var idx = list.findIndex(function (i) { return i.id === id; });
  if (idx > -1) {
    list.splice(idx, 1);
    btn.classList.remove('active');
    axiShowToast('Removed from favorites');
  } else {
    list.push({ id: id, handle: handle });
    btn.classList.add('active');
    axiShowToast('Added to favorites');
  }
  axiSaveFavorites(list);
  axiUpdateHeaderBadge();
}
function axiInitFavorites() {
  var list = axiGetFavorites();
  document.querySelectorAll('.sticky-add-to-cart__favorite, .header-actions__favorite, .product-media-gallery__favorite').forEach(function (btn) {
    if (btn.dataset.axiBound) return;
    btn.dataset.axiBound = 'true';
    var productId = btn.dataset.productId;
    if (productId && list.some(function (i) { return i.id === productId; })) {
      btn.classList.add('active');
    }
    if (productId) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        axiToggleFavorite(btn);
      });
    }
  });
  axiUpdateHeaderBadge();
}
document.addEventListener('DOMContentLoaded', axiInitFavorites);
if (document.readyState !== 'loading') axiInitFavorites();